module.exports = __webpack_public_path__ + "static/embeded_form-eeffa9584cd2dbe0a5a9aa19b7160d1e.png";